<template>
  <div class="section">
    <!-- 综合评价 -->
    <div class="info-content">
      <div v-if="isBehaviorReport == true">
        <img :src="images.icon1" class="title-icon" />
        <div style="padding: 0 80px">
          <div class="font-title">认知能力</div>
          <div class="font-content" style="margin-top: 6px">
            {{ this.model.zhpj_rz }}
          </div>
        </div>
      </div>

      <div style="padding-top: 40px">
        <img :src="images.icon2" class="title-icon" />
        <div style="padding: 0 80px">
          <div class="font-title">心理健康</div>
          <div class="font-content" style="margin-top: 6px">
            {{ this.model.zhpj_xl }}
          </div>
        </div>
      </div>

      <div
        style="padding-top: 60px"
        v-if="isPerReport == true"
      >
        <img :src="images.icon5" class="title-icon" />
        <div style="padding: 0 80px">
          <div class="font-title">人格特质</div>
          <div class="font-content" style="margin-top: 6px">
            <span v-if="this.good.length != 0">
              具备良好的
              <div
                v-for="(item, index) in this.good"
                :key="index"
                style="display: inline"
              >
                <span
                  style="display: inline; font-weight: bold"
                  v-if="index != good.length - 1"
                >
                  {{ item }}、
                </span>
                <span style="display: inline; font-weight: bold" v-else>
                  {{ item }}。</span
                >
              </div>
            </span>

            <span v-if="this.mid.length != 0">
              在
              <span
                v-for="(item, index) in this.mid"
                :key="index"
                style="display: inline"
              >
                <span
                  style="display: inline; font-weight: bold"
                  v-if="index != mid.length - 1"
                >
                  {{ item }}、
                </span>
                <span style="display: inline; font-weight: bold" v-else>
                  {{ item }}</span
                >
              </span>
              表现一般。
            </span>

            <span v-if="this.bad.length != 0">
              在
              <span
                v-for="(item, index) in this.bad"
                :key="index"
                style="display: inline"
              >
                <span
                  style="display: inline; font-weight: bold"
                  v-if="index != bad.length - 1"
                >
                  {{ item }}、
                </span>
                <span style="display: inline; font-weight: bold" v-else>
                  {{ item }}</span
                >
              </span>
              方面能力偏弱。
            </span>
          </div>

 
        </div>
      </div>

      <div style="padding-top: 40px" v-if="isTeamReport == true">
        <img :src="images.icon3" class="title-icon" />
        <div style="padding: 0 80px">
          <div class="font-title">团队适配</div>
          <div class="font-content" style="margin-top: 6px">
            <div
              v-if="this.detailTuan.length < 3 || this.detailTuan.length == 3"
            >
              典型团队角色：
            </div>
            <div
              v-if="this.detailTuan.length < 3 || this.detailTuan.length == 3"
            >
              <div v-for="(item, index) in this.detailTuan" :key="index">
                {{ item.name }} —— {{ item.define }}
              </div>
            </div>

            <div v-if="this.detailTuan.length > 3">无典型团队角色定位。</div>
          </div>
        </div>
      </div>

      <div style="padding-top: 40px">
        <img :src="images.icon4" class="title-icon" />
        <div style="padding: 0 80px">
          <div class="font-title">关键总结</div>
          <div class="font-content" style="margin-top: 6px">
            {{ this.model.zhpj_zj }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "model",
    "PersonResult",
    "detailTuan",
    "isPerReport",
    "isBehaviorReport",
    "isTeamReport",
    "IsZero",
  ],
  data() {
    return {
      images: {
        icon1: require("../../../assets/images/all/icon1.png"),
        icon2: require("../../../assets/images/all/icon2.png"),
        icon3: require("../../../assets/images/all/icon3.png"),
        icon4: require("../../../assets/images/all/icon4.png"),
        icon5: require("../../../assets/images/all/icon5.png"),
      },
      good: [], //人格特性好的指标
      mid: [], //not bad
      bad: [], //bad
      title: [
        "实干者",
        "协调者",
        "推进者",
        "创新者",
        "信息者",
        "监督者",
        "凝聚者",
        "完善者",
        "专家型",
      ],
      detail: [],
      TuanDetail: [],
    };
  },
  mounted() {
    if (this.PersonResult) {
      this.loadResult();
    }
  },
  watch: {
    PersonResult(val) {
      if (val) {
        this.loadResult();
      }
    },
  },
  methods: {
    loadResult() {
      this.PersonResult.map((item) => {
        if (item.score >= 8 && item.score <= 10) {
          this.good.push(item.name);
        }
        if (item.score >= 4 && item.score <8) {
          this.mid.push(item.name);
        }
        if (item.score >= 0 && item.score < 4) {
          this.bad.push(item.name);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  background-image: url("../../../assets/images/all/bg1.png");
  height: 1124px;
  overflow: hidden;
  .info-content {
    padding: 420px 60px;
  }
  .font-title {
    font-weight: bold;
    font-size: 19px;
  }
  .font-content {
    font-size: 14px;
  }
  .title-icon {
    width: 10%;
    float: left;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/report/four/pageTwo.vue